import React from "react";
import { IndustryPartsTable } from "../../organisms/IndustryPartsTable";

// Setores disponíveis na lista do Opaco (mesma view /SAGAViewPecasSetor, só mudam as peças)
const OPACO_SECTORS = ['21CORTE', '27SERIG', '28INSFIN'];

export const IndustryPartsTemplate = () => {
  return (
    <IndustryPartsTable />
  );
}

export const IndustryPartsTemplateOpaco = () => {
  return (
    <IndustryPartsTable allowedSectors={OPACO_SECTORS} />
  );
}


